// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import '../src/assets/scss/reset.scss'
import vueAMap from 'vue-amap'
import { post, get } from './axios/request'
import loadingDirective from './assets/directive/loading'
import './../src/assets/css/loading.css'
import './../src/assets/css/style.css'
import './assets/fontIcon/css/iconfont.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
// 定义全局变量
Vue.prototype.$post = post
Vue.prototype.$get = get

Vue.use(vueAMap)
vueAMap.initAMapApiLoader({
  key: '0f611948e0cab2a7124d21afc0e792d5',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})

// 使用懒加载
Vue.use(VueLazyload, {
  // error: 'dist/error.png', // 当加载图片失败的时候
  // loading:'/imgs/loading-svg/loading-bars.svg' // 当加载图片成功的时候
})

Vue.config.productionTip = false

// 自定义loading指令
Vue.directive('loading', loadingDirective)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js